export default "skymp5-front/500f1f152d3ad8ad6e3254f179adcdfb.png";